
import { defineComponent } from 'vue';
import { 
	galleryComposition, dataComposition, additionalButtonsComposition, menuComposition
} from '../services';

/**
 * Vue components define
 */
export default defineComponent({
	setup() {
		return { 
			...dataComposition(), ...galleryComposition(), ...additionalButtonsComposition(), 
			...menuComposition() 
		};
	},
})
